<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de histórico de papel por lotação">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/administracao/relatorio-historico-papel-lotacao/List'

export default {
    components: {
        List,
    },
}
</script>